import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertCircle } from 'react-icons/fi';

const DigitalNotice = () => {
  return (
    <div className="bg-amber-50 border-y border-amber-100 py-6">
      <div className="max-w-4xl mx-auto px-4 text-center flex flex-col sm:flex-row items-center justify-center gap-3">
        <SafeIcon icon={FiAlertCircle} className="text-amber-600 text-2xl flex-shrink-0" />
        <p className="text-stone-700 font-medium">
          <strong className="text-amber-800">IMPORTANT:</strong> We do not ship physical bookmarks. This is a <strong className="text-amber-800 uppercase">Digital Download</strong> emailed to you instantly upon purchase for immediate use! Print as many as you like!
        </p>
      </div>
    </div>
  );
};

export default DigitalNotice;